import {Shower} from "../../parts/shower";
import {IntermediatePart} from "../../intermediatePart";

export default class CeilingPanels extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'ceiling_panels';
    this.partName = 'Ceiling Panels';
    this.translateId = "visualizer.bathroom.ceiling_panels";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    if (dbFeature.metaData && dbFeature.metaData["Coords"]) {
      dbFeature.metaData["Coords"] = null;
    }
    return super.load_(dbFeature, new CeilingPanels());
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions(); // roomLayout
    const shower = this.getParent().layout.parts[Shower.id];
    if (shower && shower.showerSize()) {
      conditions.push({
        propName: "ShowerSize",
        propValue: shower.showerSize()
      })
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Walls.CeilingPanels;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }

}
